import React from "react";
import { usePortalAuth } from "../../lib/portal-auth-context";
import {
  DataTable,
  PageHeader,
  StatusPill,
  formatDate,
  useFetchList,
} from "./portal-ui";
import { Link } from "react-router-dom";
import { FilePlus } from "@phosphor-icons/react";

export default function PortalQuotes() {
  const { api } = usePortalAuth();
  const { items, loading } = useFetchList(api, "/quotes");

  return (
    <div data-testid="portal-quotes-page">
      <PageHeader
        eyebrow="Cotizaciones"
        title="Mis cotizaciones"
        subtitle="Historial de solicitudes enviadas desde tu cuenta."
        action={
          <Link to="/portal/new-quote" className="btn-primary" data-testid="portal-quotes-new">
            <FilePlus size={16} weight="bold" /> Nueva solicitud
          </Link>
        }
      />
      <DataTable
        testId="portal-quotes-table"
        loading={loading}
        rows={items}
        emptyMsg="Aún no has enviado cotizaciones."
        columns={[
          { key: "created_at", label: "Fecha", render: (r) => formatDate(r.created_at) },
          {
            key: "products",
            label: "Categorías",
            render: (r) =>
              Array.isArray(r.products) && r.products.length
                ? r.products.join(", ")
                : "—",
          },
          {
            key: "message",
            label: "Detalle",
            render: (r) => (
              <span className="line-clamp-2 block max-w-sm">
                {r.message || "—"}
              </span>
            ),
          },
          {
            key: "status",
            label: "Estado",
            render: (r) => <StatusPill value={r.status || "new"} />,
          },
        ]}
      />
    </div>
  );
}
